
const LOCAL_BASE_URL = "https://ebank.samurdhi.gov.lk/samurdhi-ebank-mis";
const BASE_URL = "http://localhost:8085/mis";
export const SYS_CONFIG = {
    baseUrl: BASE_URL,
    localBaseUrl: LOCAL_BASE_URL
};